import { createElement, debounce } from './globalFunctions'

const header = document.querySelector('#header')

/**
 * Moves the navigation to the top of the header.
 */
const moveNavigationToHeaderTop = () => {
	if (!header) return
	const navigation = header.querySelector('#navigation')
	const siteNameWrapper = header.querySelector('.site-name-wrapper')
	if (!navigation || !siteNameWrapper) return
	siteNameWrapper.after(navigation)
	const menuHelper = header.querySelector('.menu-helper')
	if (!menuHelper) return
	navigation.parentElement.insertBefore(menuHelper, navigation.nextElementSibling)
}

/**
 * Moves the login button to the navigation buttons.
 */
const moveLoginToNavigationButtons = () => {
	if (!header) return
	const navigationButtons = header.querySelector('.navigation-buttons')
	const loginButton = document.querySelector('.top-nav-button-account') || document.querySelector('.top-nav-button-login')
	if (!navigationButtons || !loginButton) return
	navigationButtons.prepend(loginButton)
}

/**
 * Moves the search toggle to the navigation buttons.
 */
const moveSearchToggleToNavigationButtons = () => {
	if (!header) return
	const navigationButtons = header.querySelector('.navigation-buttons')
	const searchToggle = header.querySelector('.toggle-window[data-target="search"]')
	if (!navigationButtons || !searchToggle) return
	navigationButtons.prepend(searchToggle)
}

/**
 * Moves the hamburger to the navigation buttons.
 */
const moveHamburgerToNavigationButtons = () => {
	if (!header) return
	const navigationButtons = header.querySelector('.navigation-buttons')
	const hamburger = document.querySelector('.toggle-window[data-target="navigation"]')
	if (!navigationButtons || !hamburger) return
	navigationButtons.append(hamburger)
}

/**
 * Moves the top navigation bar to the navigation in on mobile devices.
 */
const handleNavBarMoving = (topNavigationBar, navigationIn) => {
	if (!header) return
	if (window.innerWidth >= 768) {
		if (topNavigationBar.nextElementSibling !== header) {
			header.parentElement.insertBefore(topNavigationBar, header)
		}
	} else {
		if (topNavigationBar.parentElement !== navigationIn) {
			navigationIn.appendChild(topNavigationBar)
		}
	}
}

/**
 * Moves the top navigation bar to the navigation in on mobile devices.
 */
const moveTopNavToHeader = () => {
	if (!header) return
	const topNavigationBar = document.querySelector('.top-navigation-bar')
	const navigationIn = document.querySelector('.navigation-in')
	if (!topNavigationBar || !navigationIn) return
	handleNavBarMoving(topNavigationBar, navigationIn)
	document.addEventListener('resizeEnd', () => {
		handleNavBarMoving(topNavigationBar, navigationIn)
	})
}

const moveTopNavMenuToHeader = () => {
	const topNavMenu = document.querySelector('.top-navigation-bar-menu')
	const navigationIn = document.querySelector('.navigation-in')
	const navBtns = document.querySelector('.navigation-buttons')
	// const
	if (!header || !topNavMenu) return
	if (window.innerWidth < 768) {
		if (navigationIn && topNavMenu.parentElement !== navigationIn) {
			navigationIn.appendChild(topNavMenu)
		}
	} else {
		if (navBtns && topNavMenu.nextElementSibling !== navBtns) {
			navBtns.before(topNavMenu)
		}
	}
}

/**
 * Creates a wrapper for the second level of the menu.
 * Used for designs with banner in menu for example.
 */
const createMenuLevel2Wrap = () => {
	if (!header) return
	const menuLvl2s = document.querySelectorAll('#navigation .menu-level-2')
	for (const menuLvl2 of menuLvl2s) {
		const helper = createElement('div', ['menu-level-2-helper'])
		menuLvl2.parentElement.insertBefore(helper, menuLvl2)
		helper.appendChild(menuLvl2)
		const menuLvl2Images = menuLvl2.querySelectorAll('li .menu-image img')
		for (const img of menuLvl2Images) {
			if (img.hasAttribute('data-src') && img.src != img.getAttribute('data-src')) img.src = img.getAttribute('data-src')
		}
	}
}

/**
 * Sets the sticky header behavior.
 */
const setStickyHeader = () => {
	if (!header) return
	let initialYScroll = 0
	const debouncedScroll = debounce(function () {
		const headerOffsetTop = header.offsetTop
		const windowScrollTop = window.scrollY
		if (headerOffsetTop <= windowScrollTop) {
			header.classList.add('sticky')
		} else {
			header.classList.remove('sticky')
		}
		if (windowScrollTop > initialYScroll) {
			header.classList.remove('scroll-up')
			header.classList.add('scroll-down')
		} else {
			header.classList.remove('scroll-down')
			header.classList.add('scroll-up')
		}
		initialYScroll = windowScrollTop
	}, 100)
	window.addEventListener('scroll', debouncedScroll)
}

/**
 * Sets the header top height CSS variable `--header-top-height`.
 * Used for designs with sticky header.
 */
const setHeaderTopHeightVariable = () => {
	if (!header) return
	const headerTop = header.querySelector('.header-top')
	const search = header.querySelector('.header-top .search')
	const siteMessage = document.querySelector('.site-msg.information') || 0
	if (headerTop) {
		if (window.innerWidth <= 767) {
			header.style.setProperty('--header-top-height', `${headerTop.clientHeight + (siteMessage ? siteMessage.clientHeight : 0)}px`)
		} else {
			header.style.setProperty('--header-top-height', `${headerTop.clientHeight}px`)
		}
	}
}

// move banner to menu
const moveBannerToMenu = () => {
	const menuBannerSpan = document.querySelector('footer .menu-banner')
	if (menuBannerSpan) {
		const menuBanner = menuBannerSpan.closest('.banner').parentElement
		// if (window.innerWidth >= 768) {
		const menuLvl2helpers = document.querySelectorAll('.menu-level-2-helper')
		menuLvl2helpers.forEach((helper) => {
			helper.appendChild(menuBanner.cloneNode(true))
		})
		menuBanner.remove()
		// } else {
		// 	const navigation = document.querySelector('#navigation')
		// 	if (navigation) {
		// 		navigation.appendChild(menuBanner)
		// 	} else {
		// 		menuBanner.remove()
		// 	}
		// }
	}
}

// create menu level 2 headers
const createMenuLevel2Headers = () => {
	const menuLevel1Li = document.querySelectorAll('.menu-level-1 > li')
	menuLevel1Li.forEach((li) => {
		const headerContent = li.querySelector('a > b').textContent
		const menuLevel2Header = createElement('h6', ['menu-level-heading'], headerContent)
		const wrapper = createElement('div', ['menu-level-2-header'])

		wrapper.appendChild(menuLevel2Header)
		const menuLevel2Helper = li.querySelector('.menu-level-2-helper')
		if (menuLevel2Helper) menuLevel2Helper.prepend(wrapper)
	})
}

const moveCurrencySwitcher = () => {
	const currencySwitcher = document.querySelector('.top-navigation-tools .dropdown')
	const navigationButtons = document.querySelector('.navigation-buttons')
	if (!currencySwitcher || !navigationButtons) return
	navigationButtons.prepend(currencySwitcher)
}

export {
	moveNavigationToHeaderTop,
	moveLoginToNavigationButtons,
	moveSearchToggleToNavigationButtons,
	moveHamburgerToNavigationButtons,
	moveTopNavToHeader,
	createMenuLevel2Wrap,
	setStickyHeader,
	setHeaderTopHeightVariable,
	moveBannerToMenu,
	createMenuLevel2Headers,
	moveTopNavMenuToHeader,
	moveCurrencySwitcher,
}
